import { is_mobile } from './utils'

//
// Video sprites
//
const canvasDensity = is_mobile ? 3 : Math.min(2, window.devicePixelRatio);

function VideoSprite(vars, options) {
    let $this = this;
    this.name = vars.name;
    this.container = vars.container;
    this.canvas = this.container.querySelector("canvas", {
        alpha: true
    });
    this.parent = vars.parent;
    this.options = options;

    this.width = vars.parent ? this.parent.clientWidth : window.innerWidth;
    this.height = vars.parent ? this.parent.clientWidth / options.ratio : window.innerHeight;
    this.width *= canvasDensity;
    this.height *= canvasDensity;

    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.ctx = this.canvas.getContext("2d");
    this.images = [];
    this.videoLoaded = false;
    this.currentFrame = "last";
    this.lastFrame = new Image();
    this.lastFrame.src = this.options.baseURL + this.options.firstFrame || this.options.lastFrame;

    this.lastFrame.addEventListener("load", function () {
        $this.draw();
    });

    this.load = function (callback) {
        let promises = [];
        for (let i = 0; i < $this.options.frameCount; i++) {
            promises.push(
                new Promise((resolve) => {
                    let img = new Image();
                    img.src = $this.options.baseURL + (i).toString().padStart($this.options.numberPadding, "0") + $this.options.extension || ".jpg";

                    $this.images[i] = img;

                    img.addEventListener("load", function (e) {
                        // noinspection JSUnresolvedFunction
                        e.target.setAttribute("data-loaded", "true");
                        resolve(true);
                    });

                    img.addEventListener("error", function (e) {
                        // noinspection JSUnresolvedFunction
                        e.target.setAttribute("data-loaded", "false");
                        resolve(true);
                    });
                })
            )
        }

        Promise.all(promises).then(() => {
            $this.videoLoaded = true;
            callback();
        });
    }

    this.draw = function () {
        // if (this.canvas.getAttribute("data-visible") === "false") return;
        let img;
        if (this.currentFrame === "last") {
            img = this.lastFrame
        } else {
            img = this.images[this.currentFrame];
        }

        if (img) {
            try {
                let y = (this.height - this.width / this.options.ratio) / 2;
                this.ctx.drawImage(img, 0, y, this.width, this.width / this.options.ratio);
            } catch (error) {
                console.log("error loading image: " + img.src);
            }
        }
    }

    window.addEventListener('resize', function () {
        if ($this.parent) {
            $this.width = $this.parent.clientWidth;
            $this.height = $this.parent.clientWidth / $this.options.ratio;
        } else {
            $this.width = window.innerWidth;
            $this.height = window.innerHeight;
        }

        $this.width *= canvasDensity;
        $this.height *= canvasDensity;

        $this.canvas.width = $this.width;
        $this.canvas.height = $this.height;
    });
}

export {
    VideoSprite
}
